import {
  AlertCircle,
  AlertOctagon,
  AlertTriangle,
  ArrowRight,
  Banknote,
  BarChart3,
  Bell,
  Calendar,
  Check,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  ChevronUp,
  Clock,
  Compass,
  CreditCard,
  FileText,
  Globe,
  Hammer,
  Heart,
  HelpCircle,
  Inbox,
  Info,
  Key,
  LayoutDashboard,
  Lock,
  LogIn,
  LogOut,
  Mail,
  Map,
  MapPin,
  MessageSquare,
  Minus,
  Moon,
  Package,
  Plus,
  Receipt,
  RefreshCw,
  RotateCcw,
  Search,
  Send,
  Settings,
  Shield,
  ShoppingBag,
  ShoppingCart,
  SlidersHorizontal,
  Smartphone,
  Star,
  Store,
  Tag,
  Target,
  Trash2,
  TrendingDown,
  TrendingUp,
  Truck,
  Upload,
  User,
  Wallet,
  X,
  XCircle,
} from "lucide-react";

// Explicit registry — only these icons ship in the bundle. Accepts kebab-case
// names like the design prototype. To add an icon: import it above and add the
// kebab-case name here. Unknown names render nothing (no crash).
const REGISTRY = {
  "alert-circle": AlertCircle,
  "alert-octagon": AlertOctagon,
  "alert-triangle": AlertTriangle,
  "arrow-right": ArrowRight,
  banknote: Banknote,
  "bar-chart-3": BarChart3,
  bell: Bell,
  calendar: Calendar,
  check: Check,
  "chevron-down": ChevronDown,
  "chevron-left": ChevronLeft,
  "chevron-right": ChevronRight,
  "chevron-up": ChevronUp,
  clock: Clock,
  compass: Compass,
  "credit-card": CreditCard,
  "file-text": FileText,
  globe: Globe,
  hammer: Hammer,
  heart: Heart,
  "help-circle": HelpCircle,
  inbox: Inbox,
  info: Info,
  key: Key,
  "layout-dashboard": LayoutDashboard,
  lock: Lock,
  "log-in": LogIn,
  "log-out": LogOut,
  mail: Mail,
  map: Map,
  "map-pin": MapPin,
  "message-square": MessageSquare,
  minus: Minus,
  moon: Moon,
  package: Package,
  plus: Plus,
  receipt: Receipt,
  "refresh-cw": RefreshCw,
  "rotate-ccw": RotateCcw,
  search: Search,
  send: Send,
  settings: Settings,
  shield: Shield,
  "shopping-bag": ShoppingBag,
  "shopping-cart": ShoppingCart,
  "sliders-horizontal": SlidersHorizontal,
  smartphone: Smartphone,
  star: Star,
  store: Store,
  tag: Tag,
  target: Target,
  "trash-2": Trash2,
  "trending-down": TrendingDown,
  "trending-up": TrendingUp,
  truck: Truck,
  upload: Upload,
  user: User,
  wallet: Wallet,
  x: X,
  "x-circle": XCircle,
};

export function Icon({ name, size = 16, color = "currentColor", strokeWidth = 1.5, style }) {
  const Cmp = REGISTRY[name];
  if (!Cmp) return null;
  return (
    <Cmp
      size={size}
      color={color}
      strokeWidth={strokeWidth}
      style={{ display: "inline-flex", flexShrink: 0, ...style }}
    />
  );
}
